import { isEmpty, isObjectLike } from 'lodash';

import { mergeModelTrimsBitField } from 'commons-vehicle/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js';
import * as DataOrigins from 'commons-vehicle/constants/dataOrigins.js';
import DrivePowerTrainModel from 'commons-vehicle/ModelYear/models/DrivePowerTrainModel.js';
/* eslint no-bitwise: 0 */

function resetDrivePowerTrainFromModelData(modelData) {
    const drivePowerTrainSelectionCode =
        `${modelData.driveTrain.selectionCode}|` +
        `${modelData.engine.getSelectionCode()}|` +
        `${modelData.transmission.getSelectionCode()}`;

    const drivePowerTrainRank =
        modelData.driveTrain.rank * 100000 + (modelData.engine.hp + 1000) * 10 + modelData.transmission.rank;

    return new DrivePowerTrainModel({
        trimsBitField: 0,
        trimsBitFields: [],
        selectionCode: drivePowerTrainSelectionCode,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false,
        rank: drivePowerTrainRank,
        driveTrain: modelData.driveTrain,
        engine: modelData.engine,
        transmission: modelData.transmission,
        configurationIds: {},
        bestOptionsPackageCode: '',
    });
}

export function resetDrivePowerTrainFromOriginData(dataOrigin, originDrivePowerTrainData) {
    if (isEmpty(originDrivePowerTrainData) || !isObjectLike(originDrivePowerTrainData)) {
        return new DrivePowerTrainModel();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new DrivePowerTrainModel();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetDrivePowerTrainFromModelData(originDrivePowerTrainData);

        default:
            return new DrivePowerTrainModel();
    }
}

export function addDrivePowerTrainConfigurationId(drivePowerTrain, configurationId, configuration) {
    const { trimsBitField, trimsBitFields } = mergeModelTrimsBitField(drivePowerTrain, configuration, true);

    const configurationIds = drivePowerTrain.get('configurationIds');
    configurationIds[configurationId] = configuration.trimsBitField;

    return drivePowerTrain
        .set('trimsBitField', trimsBitField)
        .set('trimsBitFields', trimsBitFields)
        .set('configurationIds', configurationIds);
}

export default {
    resetDrivePowerTrainFromModelData,
    resetDrivePowerTrainFromOriginData,
    addDrivePowerTrainConfigurationId,
};
